import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// comicsState: false
	},
	mutations: {
		// SET_comicsState: (state, params) => {
		// 	state.comicsState = params
		// },
	},
	getters: {
	},
	actions: {

	}
})
